import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=399f49f2&scoped=true&"
import script from "./CreateNew.vue?vue&type=script&lang=js&"
export * from "./CreateNew.vue?vue&type=script&lang=js&"
import style0 from "./CreateNew.vue?vue&type=style&index=0&id=399f49f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f49f2",
  null
  
)

export default component.exports